let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5qqwM")).then(() => parcelRequire('dBf4A'));